import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";

export function useKeyboardVisible() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      let showHandle: { remove: () => Promise<void> } | undefined;
      let hideHandle: { remove: () => Promise<void> } | undefined;
      let cancelled = false;

      import("@capacitor/keyboard").then(({ Keyboard }) => {
        if (cancelled) return;
        Keyboard.addListener("keyboardWillShow", () => setVisible(true)).then(
          (h) => (showHandle = h),
        );
        Keyboard.addListener("keyboardWillHide", () => setVisible(false)).then(
          (h) => (hideHandle = h),
        );
      });

      return () => {
        cancelled = true;
        showHandle?.remove();
        hideHandle?.remove();
      };
    }

    const vv = window.visualViewport;
    if (!vv) return;
    const onResize = () => {
      setVisible(window.innerHeight - vv.height > 100);
    };
    vv.addEventListener("resize", onResize);
    return () => vv.removeEventListener("resize", onResize);
  }, []);

  return visible;
}
